import { render, staticRenderFns } from "./FinalPage.vue?vue&type=template&id=162d940e&scoped=true"
import script from "./FinalPage.vue?vue&type=script&lang=js"
export * from "./FinalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d940e",
  null
  
)

export default component.exports